export const muiStyles = () => ({
    root: {
        height: '100%',
        overflowY: 'auto' as const,
        overflowX: 'hidden' as const
    }
});